import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=6681e3dc&"
import script from "./coupon.vue?vue&type=script&lang=ts&"
export * from "./coupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "coupon.vue"
export default component.exports